import React from 'react'
import { Link } from "react-router-dom";
import { GrUserAdmin } from "react-icons/gr";
import Logo from '../../components/logo/logo.components';

function RefundPolicy() {
  return (
    <main
      className="container-fluid forgot-password-container pb-4"
      style={{ height: "auto" }}
    >
      <nav className="navbar fixed-top navbar-light">
        <Link
          to="/"
          className="navbar-brand"
          style={{ fontSize: "22px", color: "#ffffff" }}
        >
          <Logo size="small" />
        </Link>

        <Link
          to="/"
          className="btn btn-primary btn-login  my-2 my-sm-0 px-4"
          type="submit"
        >
          <GrUserAdmin size="1.2em" style={{ marginRight: "5px" }} /> Login
        </Link>
      </nav>
      <article className="container mt-5 pt-5">
        <div className="row">
          <div className="col-md-12">
            <h1 className="text-white">Refund Policy</h1>
          </div>

          <div className="col-md-12 text-white mt-3">
            <p>
              <strong>Last Updated: April 01, 2026</strong>
            </p>
          </div>

          <div className="col-md-12 text-white mt-4">
            <p>
              At 3for3 Networking, we use a credit-based system that allows
              members to schedule curated 1-on-1 networking calls with other
              professionals. This policy outlines how refunds and credit
              adjustments are handled on our platform.
            </p>

            <ol className='mb-3'>
              <li>
                <h5>
                  <strong>All Credit Purchases Are Final</strong>
                </h5>
                <p>
                  All purchases of credits are non-refundable. Once credits are
                  added to your account, they cannot be exchanged, returned, or
                  converted into cash under any circumstance.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Credit Use for Scheduled Calls</strong>
                </h5>
                <p>
                  Credits are used to schedule calls with other participants on
                  the platform. Once a credit is used to book a call:
                </p>
                <ul className="mb-3">
                  <li>
                    <strong>It cannot be refunded</strong>, even if the call is
                    canceled or the participant does not attend.
                  </li>
                  <li>
                    <strong>Missed or canceled calls</strong>, regardless of
                    reason or notice period, do not qualify for credit
                    reinstatement.
                  </li>
                </ul>
              </li>

              <li>
                <h5>
                  <strong>Platform or Technical Issues</strong>
                </h5>
                <p>
                  If a scheduled call fails due to a{" "}
                  <strong>verified platform-related technical error</strong>{" "}
                  (e.g., system outage or connection failure caused by 3for3),
                  you may request credit reinstatement. To be considered for
                  reinstatement:
                </p>
                <ul className="mb-3">
                  <li>
                    Submit a request to{" "}
                    <a href="mailto:susan@3for3networking.com">
                      susan@3for3networking.com
                    </a>{" "}
                    within 24 hours of the missed call.
                  </li>
                  <li>
                    Include relevant details and any available screenshots or
                    documentation.
                  </li>
                </ul>
                <p>
                  All requests are reviewed on a case-by-case basis. We reserve
                  the right to deny reinstatement if the issue is not due to a
                  platform error.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Promotional or Bonus Credits</strong>
                </h5>
                <p>
                  Credits received through promotions, giveaways, or bonuses may
                  be subject to additional terms and{" "}
                  <strong>cannot be refunded or transferred</strong>. These
                  promotional credits may also carry an expiration date, which
                  will be stated at the time of issuance.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Expiration and Account Use</strong>
                </h5>
                <p>Credits do not currently expire but are:</p>
                <ul className="mb-3">
                  <li>
                    <strong>Non-transferable</strong>
                  </li>
                  <li>
                    <strong>Only usable</strong> within the 3for3 Networking
                    platform
                  </li>
                </ul>
                <p>
                  We reserve the right to modify credit expiration policies with
                  advance notice.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Policy Updates</strong>
                </h5>
                <p>
                  This policy may be updated periodically. Any changes will be
                  reflected on this page with an updated effective date.
                </p>
              </li>
            </ol>

            <h4>
              <strong>Need Assistance?</strong>
            </h4>
            <p>
              For questions or support, contact us at{" "}
              <a href="mailto:susan@3for3networking.com">
                susan@3for3networking.com
              </a>
              .
            </p>
          </div>
        </div>
      </article>
    </main>
  );
}

export default RefundPolicy;